import { MDBBtn } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import TopicsDisplay from '../../../components-user/topics/TopicsDisplay';

export default function NewsTopicSection({
  topics,
  topicGroups,
  selectedTopics,
  unknownTopicNames,
  toggleSelectTopicsModal,
  handleSetSelectedTopics,
  getFieldError,
  markFieldTouched,
}) {
  const { t } = useTranslation();
  const topicError = getFieldError('cMSNewsTopicId');

  return (
    <>
      <p className="text-muted mb-3">
        {t("Select one topic that best describe your news article.")}
      </p>
      <MDBBtn
        onClick={() => { markFieldTouched('cMSNewsTopicId'); toggleSelectTopicsModal(); }}
        color="primary"
        outline
        size="sm"
      >
        {t("Select Topic")}
      </MDBBtn>
      {topicError && (
        <div className="text-danger small mt-2">{topicError}</div>
      )}
      {topics.length > 0 && topicGroups.length > 0 && selectedTopics.length > 0 && (
        <TopicsDisplay
          topics={topics}
          topicGroups={topicGroups}
          selectedTopics={selectedTopics}
          unknownTopicNames={unknownTopicNames}
          onRemoveTopic={(id) => handleSetSelectedTopics(selectedTopics.filter(sid => sid !== id))}
        />
      )}
    </>
  );
}
